import { render, staticRenderFns } from "./BillSignList.vue?vue&type=template&id=5182e62a&scoped=true&"
import script from "./BillSignList.vue?vue&type=script&lang=js&"
export * from "./BillSignList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5182e62a",
  null
  
)

export default component.exports